import React, { useState } from 'react';
import { CalendarIcon, FilterIcon, ArrowUpIcon, ArrowDownIcon, DollarSignIcon } from 'lucide-react';
const Revenue = () => {
  const [dateRange, setDateRange] = useState('last30Days');
  const revenueMetrics = [{
    title: 'Total Revenue',
    value: '$283,452',
    change: '+15.3%',
    isPositive: true
  }, {
    title: 'New Revenue',
    value: '$24,531',
    change: '+12.5%',
    isPositive: true
  }, {
    title: 'Expansion Revenue',
    value: '$8,245',
    change: '+5.2%',
    isPositive: true
  }, {
    title: 'Churned Revenue',
    value: '$4,127',
    change: '-2.1%',
    isPositive: false
  }];
  const revenueByPlan = [{
    plan: 'Basic Plan',
    revenue: 86400,
    percentage: 30
  }, {
    plan: 'Pro Plan',
    revenue: 144000,
    percentage: 50
  }, {
    plan: 'Enterprise',
    revenue: 57600,
    percentage: 20
  }];
  return <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-800">Revenue Analytics</h1>
        <div className="flex flex-wrap gap-2">
          <div className="relative">
            <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="appearance-none pl-10 pr-10 py-2 border border-gray-300 bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm">
              <option value="last7Days">Last 7 days</option>
              <option value="last30Days">Last 30 days</option>
              <option value="last90Days">Last 90 days</option>
              <option value="lastYear">Last year</option>
              <option value="custom">Custom range</option>
            </select>
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <CalendarIcon size={16} className="text-gray-500" />
            </div>
          </div>
          <button className="flex items-center px-4 py-2 border border-gray-300 bg-white rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm">
            <FilterIcon size={16} className="mr-2 text-gray-500" />
            Filters
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {revenueMetrics.map((metric, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium text-gray-500">
                {metric.title}
              </h3>
              <span className={`flex items-center text-sm font-medium ${metric.isPositive ? 'text-green-600' : 'text-red-600'}`}>
                {metric.isPositive ? <ArrowUpIcon size={16} className="mr-1" /> : <ArrowDownIcon size={16} className="mr-1" />}
                {metric.change}
              </span>
            </div>
            <p className="mt-2 text-3xl font-bold text-gray-900">
              {metric.value}
            </p>
          </div>)}
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Revenue by Plan
          </h2>
          <div className="space-y-4">
            {revenueByPlan.map((plan, index) => <div key={index}>
                <div className="flex items-center justify-between text-sm mb-1">
                  <span className="font-medium">{plan.plan}</span>
                  <span className="text-gray-500">
                    ${plan.revenue.toLocaleString()}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-blue-500 h-2 rounded-full" style={{
                width: `${plan.percentage}%`
              }}></div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Monthly Revenue Growth
          </h2>
          <div className="h-64 flex items-end justify-between">
            {/* Placeholder for monthly growth chart */}
            <div className="text-center text-gray-500 w-full">
              Monthly revenue growth chart will be displayed here
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Revenue Distribution
          </h2>
          <div className="h-64 flex items-center justify-center">
            {/* Placeholder for revenue distribution chart */}
            <div className="text-center text-gray-500">
              Revenue distribution chart will be displayed here
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Revenue;